import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { parseQueryParamsObject } from "@robe/core-utils";
import { baseWebFetchOptions } from "./options";
import { resolveWebUserConfirmationErrorParams, WebUserConfirmationError } from "../errors";

export interface ConfirmationParams {
  confirmationId: string;
}

/**
 * @throws {WebUserConfirmationError}
 */
export const userConfirmation = (core: XcoreCore, params: ConfirmationParams, timeout?: number): BaseApiRequest<Response> =>
  core
    .fetch(`/api/web/user/confirmation${parseQueryParamsObject(params)}`, {
      ...baseWebFetchOptions,
      method: "GET",
      timeout,
    })
    .catch((err) => {
      const confirmationError = resolveWebUserConfirmationErrorParams(err);
      if (confirmationError) {
        throw new WebUserConfirmationError(confirmationError);
      }

      throw err;
    });
